import React from "react";
import "../../Default.css";

function Embassy() {
  return (
    <>
      <div className="page-title">Ambasada</div>
      <div className="boxes-contener">
        <div className="copyright-tekst">
          tekst zaczerpnięty ze strony internetowej MSZ
        </div>
        <div className="text-box">
          <div className="text-box-header">Ambasada RP w Lizbonie</div>
          <p>adres: Av das Descobertas 2, 1400-092 Lisboa, Portugal</p>
          <p>telefon: (+351) 213 041 410</p>
          <p>e-mail: lizbona.amb.sekretariat@msz.gov.pl</p>
        </div>
        <div className="text-box">
          <div className="text-box-header">
            Referat Konsularny Ambasady RP w Lizbonie
          </div>
          <p>adres: Av das Descobertas, 2, 1400-092 Lisboa, Portugal</p>
          <p>telefon: (+351) 21 3041437 (kontakt w godzinach pracy Urzędu)</p>
          <p>e-mail: lizbona.konsul@msz.gov.pl</p>
        </div>
        <div className="text-box">
          <div className="text-box-header">Konsul</div>
          <p>Rafał Budyta</p>
          <p>e-mail: rafal.budyta@msz.gov.pl</p>
          <br />
          <div className="paragraf">
            W sytuacjach nagłych, wymagających pilnej interwencji konsula
            możliwy jest kontakt pod numerem telefonu:
          </div>
          <div className="text-box-accent">+351 913 254 442</div>
          <br />
          <br />
          <div className="text-box-accent"> UWAGA! </div>
          <div className="paragraf">
            Telefon alarmowy czynny jest jedynie poza godzinami pracy ambasady i
            służy wyłącznie do kontaktów w nagłych, niecierpiących zwłoki
            sytuacjach (zagrożenie zdrowia / życia obywateli polskich, wypadki,
            hospitalizacje, zgony, aresztowania itp.)
          </div>
        </div>
      </div>
      <div className="text">
        <div className="text-box-header">Informacje od MSZ</div>
        <div className="paragraf">
          Portugalia jest krajem, w którym możemy czuć tak samo bezpiecznie jak
          w innych krajach UE. Uważaj jednak szczególnie na bardzo częste
          kradzieże kieszonkowe. Zdarzają się również włamania do samochodów
          zaparkowanych w miejscach publicznych.W związku z tym nie zostawiaj w
          samochodzie dokumentów, pieniędzy ani wartościowych przedmiotów.
          Kradzież dokumentów i pieniędzy zgłoś na najbliższym posterunku
          policji, a kradzież paszportu i dowodu osobistego dodatkowo w polskim
          urzędzie konsularnym. Aby ułatwić kontakty z miejscową policją,
          działają specjalne posterunki dla turystów (PSP Esquadra de Turismo).
          W Lizbonie taki posterunek znajduje się w centrum przy placu
          Restauradores, a w Porto przy Rua Clube dos Fenianos. Można się tam
          porozumieć w języku angielskim.
        </div>
        <div className="paragraf">
          Zachowaj ostrożność podczas kąpieli w oceanie. Groźne są zarówno duże
          fale, jak i prądy oceaniczne. Te ostanie występują również w
          miejscach, w których woda wydaje się spokojna. Wysokie fale stanowią
          zagrożenie nawet dla osoób, które nie wchodzą do wody, tylko
          przebywają blisko niej.
        </div>
        <div className="paragraf">
          W Portugalii częste są kradzieże dokumentów. Dlatego w podróż zabierz
          zarówno dowód osobisty, jak i paszport. Te dwa dokumenty przechowuj w
          osobnych miejscach. W razie kradzieży jednego z nich, wyjedziesz z
          Portugalii bez wyrabiania w urzędzie konsularnym paszportu
          tymczasowego. Pamiętaj, że wyrobienie paszportu tymczasowego wymaga
          osobistej wizyty w konsulacie w Lizbonie i jest płatne. Uzyskanie
          paszportu tymczasowego może potrwać kilka dni!
        </div>

        <div className="paragraf">
          Walutę można wymieniać w bankach i kantorach (loja de câmbio) –
          najczęściej w centrach dużych miast i na lotniskach. Pobierana jest
          niewielka prowizja. Karty płatnicze są powszechnie używane. Bardzo
          dobrze rozwinięta jest w Portugalii sieć bankomatów (multibanco).
          Niekiedy sklepy ustalają minimalną kwotę do zapłaty kartą (zwykle 5-10
          euro). UWAGA: niektóre terminale płatnicze nie obsługują zagranicznych
          kart płatniczych.
        </div>
      </div>
    </>
  );
}

export default Embassy;
